var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var moment = require('moment');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		var photoStyle = {
	  		'backgroundImage' : 'url('+this.props.author.photo+')'
  		};
  		
  		if(this.props.job && this.props.job.contact_photo){
	  		photoStyle = {
	  			'backgroundImage' : 'url('+this.props.job.contact_photo+'?ts='+moment().unix()+')'
  			}
  		}
  		
   		return (
   			<div className="job-author">
   				<div className="photo" style={photoStyle}></div>
   				<div className="info">
   					<label>{LanguageStore.get('job_ad/title/posted_by')}</label>
   					<span className="name">{this.props.author.name}</span>
   				</div>
   				<div className="clear"></div>
	  		</div>
	  	);
	}
});
